// extracted by mini-css-extract-plugin
export var gif = "_dr-0";